module.exports = __webpack_public_path__ + "media/images/import-guide-2-eed105abcfeedc903aa168d1dc9d8163.svg";